<template>
    <div class="">
        <div v-if="!tipsDialog">
            <div class="tab-container">
                <div v-for="(item,key) in tabList" :key="key" @click="handleTab(item.id)"
                :class="activeTab==item.id?'tab-content tab-item-active':'tab-content tab-item'">
                    {{item.label}}
                </div>
            </div>
            <div class="header-container">
                <div class="nav-wrapper">
                    <div v-for="(item,key) in navList" :key="key" @click="handleNav(item.id)" 
                    :class="activeNav==item.id?'nav-item-active':'nav-item'">
                        {{item.label}}
                        <div v-if="activeNav==item.id" class="nav-line-wrapper">
                            <div class="nav-line"></div>
                        </div>
                    </div>
                </div>
                <div class="search-container">
                    <div class="search-btn" @click="handleQuestion">提问</div>
                </div>
            </div>
            <div class="table-container">
                <div v-for="(item,key) in tableData" :key="key" class="table-item-wrapper">
                    <div class="table-content-wrapper">
                        <div class="table-content">
                            <div class="table-title-wrapper">
                                <div class="table-title">
                                    {{item.title}}
                                </div>
                            </div>
                            <div class="table-brief-wrapper">
                                <div class="table-brief">
                                    <div class="table-brief-item">时间：{{item.date}}</div>
                                    <div class="table-brief-item">状态：{{item.status}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="table-btn-wrapper">
                            <div class="table-btn" @click="viewDetail(item)">查看详情</div>
                        </div>
                    </div>
                </div>

                <div class="view-more-btn" @click="viewMore">查看更多</div>
            </div>
        </div>
        <!--提问-->
        <div v-else class="question-container">
            <div class="question-wrapper">
                <div class="question-form-container">
                    <el-form ref="form" :model="form" label-width="120px">
                        <el-form-item label="问题标题：">
                            <el-input v-model="form.title" placeholder="请输入问题标题"></el-input>
                        </el-form-item>
                        <el-form-item label="问题类别：">
                            <el-select v-model="form.mode" placeholder="请选择问题类别" style="width:100%;">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属地区：">
                            <el-select v-model="form.mode" placeholder="请选择所属地区" style="width:100%;">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属行业：">
                            <el-select v-model="form.mode" placeholder="请选择所属行业" style="width:100%;">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="问题详情：">
                            <el-input type="textarea" v-model="form.detail" placeholder="请输入问题详情" 
                            :rows="4"></el-input>
                        </el-form-item>
                        <el-form-item label="问题屏蔽：">
                            <el-checkbox v-model="form.checked">
                                如果您不希望其他会员看到您的问题，可以对问题设定屏蔽
                            </el-checkbox>
                        </el-form-item>
                        <el-form-item label="">
                            <div class="btn-wrapper">
                                <el-button type="primary" @click="handleSubmit">提交</el-button>
                                <div class="form-brief">
                                    （提交成功后，24小时内进行回复）
                                </div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    components:{
      
    },
    data() {
        return {
            searchVal:'',
            tabList:[
                {
                    id:'0',
                    label:'全部（20）'
                },
                {
                    id:'1',
                    label:'未解答（12）'
                },
                {
                    id:'2',
                    label:'已解答（8）'
                }
            ],
            activeTab:'0',
            navList:[
                {
                    id:'0',
                    label:'会计问题'
                },
                {
                    id:'1',
                    label:'税务问题'
                },
                {
                    id:'2',
                    label:'税务综合问题'
                }
            ],
            activeNav:'0',
            tableData:[
                {
                    id:1,
                    title:'问题标准：建筑安装行业核心业务税务管理会计准则有哪些？',
                    status:'未解答',
                    date:'2021-11-26  08:50:00'
                },
                {
                    id:2,
                    title:'问题标准：管理会计准则有哪些？',
                    status:'未解答',
                    date:'2021-11-26  08:50:00'
                },
                {
                    id:3,
                    title:'问题标准：建筑安装行业核心业务税务管理会计准则有哪些？',
                    status:'未解答',
                    date:'2021-11-26  08:50:00'
                }
            ],
            tipsDialog:false,
            form:{
                title:'',
                mode:'',
                detail:''
            }
        }
    },
    mounted(){
        
    },
    methods: {
        handleTab(target){
            this.activeTab=target;
        },
        handleNav(target){
            this.activeNav=target;
        },
        handleSearch(){

        },
        viewMore(){

        },
        viewDetail(row){
            var data={
                id:row.id,
                mode:'questionDetail'
            }
            this.$emit('mode',JSON.stringify(data));
        },
        //提问
        handleQuestion(){
            this.tipsDialog=true;
        },
        handleSubmit(){
            this.tipsDialog=false;
        }
    }
}
</script>

<style scoped>
.tab-container{
    display:flex;
}
.tab-content{
    width: 102px;
    height: 32px;
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor: pointer;
    margin-right:30px;
}
.tab-item{
    color: #333333;
}
.tab-item-active{
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    color: #FFFFFF;
}
.header-container{
    display:flex;
    justify-content: space-between;
    margin-top:36px;
}
.nav-wrapper{
    display: flex;
}
.nav-item-active{
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    height:36px;
    line-height:25px;
    margin-right:30px;
    position:relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor:pointer;
}
.nav-item{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    height:36px;
    line-height:25px;
    margin-right:30px;
    position:relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.nav-item:hover{
    cursor: pointer;
    color:#000000;
}
.nav-line-wrapper{
    width:100%;
    bottom:0px;
    left:0px;
    position:absolute;
    display: flex;
    justify-content: center;
    margin-top:6px;
}
.nav-line{
    width: 22px;
    height: 6px;
    background: #4F79ED;
    border-radius: 3px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.table-container{
    margin-top:20px;
}
.search-container{
    display:flex;
    align-items: center;
}
.page-mode-input-wrapper{
    display: flex;
    width:235px;
    position: relative;
    top:-5px;
}
.page-mode-input>>>.el-input__inner{ 
    width: 160px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right:0px !important;
}
.input-btn{
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.input-btn:hover{
    cursor:pointer;
    opacity:0.8;
}
.input-btn-icon{
    font-size: 13px;
}
.input-btn-label{
    margin-left:5px;
}
.month-wrapper{
    margin-left:20px;
    position:relative;
    top:-5px;
}
.month-wrapper>>>.el-date-editor.el-input,.el-date-editor.el-input__inner {
    width: 100px !important;
    cursor: pointer !important;
}
.month-wrapper>>>.el-input__inner{
    border:0px !important;
    font-size: 14px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #333333 !important;
    padding:0px !important;
    cursor: pointer !important;
}
.month-wrapper>>>.el-input__prefix{
    display:none !important;
}
.month-icon-wrapper{
    position:absolute;
    right:0px;
    top:11px;
}
.month-icon{
    color:#4F79ED;
}
.table-item-wrapper{
    display:flex;
    justify-content: space-between;
    padding-top:32px;
}
.table-content-wrapper{
    flex:1;
    display: flex;
    justify-content: space-between;
    padding-bottom:40px;
    border-bottom:solid #F0F0F0 1px;
}
.table-btn-wrapper{
    margin-top:27px;
}
.table-btn{
    width: 122px;
    height: 34px;
    background: linear-gradient(315deg, #5596F6 0%, #3777D6 49%, #1A5DC6 100%);
    border-radius: 20px;
    line-height:34px;
    text-align:center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.table-btn:hover{
    cursor: pointer;
    opacity:0.8;
}
.table-title-wrapper{
    display:flex;
}
.table-title{
    width: 396px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
}
.table-brief-wrapper{
    margin-top:16px;
    display:flex;
}
.table-brief-title{
    width:108px;
    height:28px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    position: absolute;
    left:0px;
    top:0px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.table-brief{
    height:28px;
    display:flex;
    justify-content: center;
    align-items: center;
}
.table-brief-item{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    margin-right:30px;
}
.view-more-btn{
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin:0 auto;
    margin-top:50px;
    margin-bottom:20px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.view-more-btn:hover{
    cursor: pointer;
    background: #F69264;
    color:#fff;
}
.team-manage-container>>>.el-dialog__body{ 
    padding: 0px !important;
}
.team-manage-container>>>.el-dialog__header{
    padding: 0px !important;
}
.dialog-header{
    width:100%;
    height: 59px;
    background: #F8FAFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}
.dialog-content{
    padding:46px 77px 60px 77px;
}
.dialog-info{
    text-align:center;
}
.table-progress-wrapper{
    margin-left:20px;
    width:324px;
    position:relative;
    top:11px;
}
.dialog-btn-wrapper{
    display: flex;
    margin-top:50px;
    justify-content: center;
}
.search-btn{
    width: 108px;
    height: 36px;
    border-radius: 18px;
    border: 1px solid #4F79ED;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4F79ED;
    text-align: center;
    line-height:36px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.search-btn:hover{
    background: linear-gradient(315deg, #5596F6 0%, #3777D6 49%, #1A5DC6 100%);
    cursor:pointer;
    color:#fff;
}
.question-container{
    min-height:600px;
    display: flex;
    justify-content: center;
    padding-bottom:60px;
}
.question-wrapper{
    width:959px;
    margin:0 auto;
    height: 616px;
    background: #FFFFFF;
    border-radius: 6px 6px 0px 0px;
    border: 1px solid #EAEAEA;
    margin-top:50px;
    padding-bottom:60px;
}
.question-form-container{
    width:550px;
    margin:0 auto;
    margin-top:50px;
}
.question-form-container>>>.el-button--primary{
    background: linear-gradient(315deg, #5596F6 0%, #3777D6 49%, #1A5DC6 100%) !important;
}
.question-form-container>>>.el-button{
    width: 122px !important;
    height: 34px !important;
    border-radius: 20px !important;
    display:flex;
    align-items: center;
    justify-content: center;
    margin:0 auto !important;
}
.btn-wrapper{
    width:100%;
    text-align: center;
    margin-top:50px;
}
.form-brief{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top:14px;
}
</style>


